import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';
import { AuthUtils } from '@core/auth/auth.utils';

@Injectable({
    providedIn: 'root'
})
export class TokenService {
    private checkInterval = 10000; // 10 segundos en milisegundos
    private alertBeforeExpire = 5 * 60 * 1000; // 5 minutos en milisegundos antes de la expiración
    private tokenCheckIntervalId: any;
    token: string;
    avisado: boolean = false;
    currentUrl: string;

    constructor(private router: Router, private authService: AuthService) {
        this.startTokenCheck();
    }

    startTokenCheck() {
        this.tokenCheckIntervalId = setInterval(() => {
            this.logCurrentUrl();
            if (this.currentUrl != '/sign-in') {
                this.checkToken();
            }
        }, this.checkInterval);
    }

    private logCurrentUrl() {
        this.currentUrl = this.router.url;
    }

    private checkToken() {
        const token = this.authService.accessToken;
        if (!token) return;

        if (!AuthUtils.isValidJwt(token)) {
            clearInterval(this.tokenCheckIntervalId);
            this.authService.signOut({
                type: 'warning',
                title: 'Sesión inválida',
                message: 'Tu sesión no es válida. Iniciá sesión nuevamente.',
                duration: 6,
            });
            return;
        }

        const expirationDate = AuthUtils._getTokenExpirationDate(token);
        if (!expirationDate) {
            clearInterval(this.tokenCheckIntervalId);
            this.authService.signOut({
                type: 'warning',
                title: 'Sesión expirada',
                message: 'Tu sesión expiró. Iniciá sesión nuevamente.',
                duration: 6,
            });
            return;
        }

        const expirationTime = expirationDate.getTime();
        const currentTime = Date.now();
        const timeUntilExpiration = expirationTime - currentTime;

        if (timeUntilExpiration <= this.alertBeforeExpire && timeUntilExpiration > 0 && !this.avisado) {
            this.avisado = true;
            const extend = confirm('Tu sesión está a punto de expirar. ¿Deseas extenderla?');
            if (extend) {
                clearInterval(this.tokenCheckIntervalId);
                this.renewToken();
            } else {
                this.authService.signOut({
                    type: 'warning',
                    title: 'Sesión finalizada',
                    message: 'La sesión fue cerrada por el usuario.',
                    duration: 6,
                });
                this.router.navigate(['/sign-out']);
            }
        }
    }

    private renewToken() {
        this.authService.renewToken().subscribe({
            next: (res: any) => {
                this.authService.accessToken = res.token;
                alert('Tu sesión ha sido extendida.');
                this.avisado = false; // Restablecer avisado para futuras verificaciones
                this.startTokenCheck();
            },
            error: (error) => {
                this.authService.signOut({
                    type: 'warning',
                    title: 'Sesión finalizada',
                    message: 'No se pudo renovar la sesión. Iniciá sesión nuevamente.',
                    duration: 6,
                });
            }
        });
    }
}
